module.exports = __webpack_public_path__ + "static/media/therapies-to-consider-blue.be461a82.svg";